import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './_styles_/UserConfigurationItem.css';
import ExpandedListTab from '../ExpandedListTab';
import { onActionKey } from '../../utils';

UserConfigurationItem.propTypes = {
    title: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    detailVisibleOnLoad: PropTypes.bool,
};

UserConfigurationItem.defaultProps = {
    detailVisibleOnLoad: false,
};

function UserConfigurationItem(props) {
    const {
        title,
        children,
        detailVisibleOnLoad,
    } = props;
    const [isDetailVisible, setDetailVisible] = useState(detailVisibleOnLoad);
    const toggleDetailVisibility = () => setDetailVisible(!isDetailVisible);
    return (
        <>
            <div
                className="user-configuration-item"
                onClick={toggleDetailVisibility}
                onKeyUp={onActionKey(toggleDetailVisibility)}
                role="button"
                tabIndex={0}
            >
                <div className="user-configuration-item--title">{title}</div>
                <div className="user-configuration-item--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && (
                <ExpandedListTab
                    className="user-configuration-item--content"
                >
                    {children}
                </ExpandedListTab>
            )}
        </>
    );
}

export default UserConfigurationItem;
